<div class="login-form">
	<h4 class="login-heading">Welcome back</h4>
	<p class="login-subline">Sign in to the MSVS console</p>
	<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-3">
		<div class="alert alert-danger" *ngIf="message">
			{{message}}
		</div>
		<div class="form-floating-underline has-icon mb-4" [ngClass]="{'active': form.get('username')?.value}">
			<input
				formControlName="username"
				appAutoFocus
				name="username"
				type="text"
				id="usernameInput"
				placeholder=" "
				autocomplete="username"
				required/>
			<label for="usernameInput">Username</label>
			<i nz-icon nzType="user" nzTheme="outline" class="field-icon"></i>
		</div>
		<button class="w-100 btn btn-primary btn-with-arrow login-submit" type="submit" [disabled]="form.invalid" *ngIf="submitting == false">
			Continue
			<i nz-icon nzType="arrow-right" nzTheme="outline"></i>
		</button>
		<button class="w-100 btn btn-primary login-submit" type="submit" [disabled]="true" *ngIf="submitting == true">
			<i nz-icon nzType="loading" nzTheme="outline"></i>
		</button>
		<div class="login-help">
			<span>Step 1 of 2</span>
		</div>
	</form>
</div>
